<template>
  <div id="app" class="d-flex" :class="[this.$route.meta.baseClass || '', layout]" :data-refera-version="appVersion" :data-build-version="buildVersion" :data-refera-environment="appEnvironment">
    <div class="initial-loader" v-if="isInitialLoadingRoute"></div>
    <component v-else :is="layout">
      <router-view />
    </component>
  </div>
</template>
<script>
window.RevampConfig = Object.freeze({
  version: process.env.VUE_APP_VERSION,
  base_url: process.env.VUE_APP_API_BASE_URL,
  api: process.env.VUE_APP_API_BASE_URL + '/api',
})

export default {
  name: 'App',
  created() {
    this.$store.dispatch('state/load')
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || 'base') + '-layout'
    },
    isInitialLoadingRoute() {
      const { name, path, matched } = this.$route
      return path === '/' && (!matched || !matched.length) && !name
    },
  },
  data() {
    return {
      appVersion: process.env.VUE_APP_VERSION,
      buildVersion: process.env.VUE_APP_BUILD_VERSION,
      appEnvironment: process.env.VUE_APP_ENV,
    }
  },
}
</script>
<style lang="scss">
// @use './styles/custom-bootstrap.scss';
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import './styles/global.scss';

</style>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app.base-layout .container-fluid {
  max-width: 1440px;
}
</style>
